import { Badge, FlexLayout } from '@deity/falcon-ui';
import { Tooltip } from 'components';
import { CACHE_FIRST, toLocalDateString } from 'contracts/constants';
import type { FC } from 'react';
import { useEffect } from 'react';
import { useGetPackageVersionLazyQuery } from 'services/graphql/generated/hooks';
import { validate as validateUuid } from 'uuid';

type PackageItemProps = {
  packageVersionKey?: string;
  prefix?: string;
  postfix?: string;
  detailed?: boolean;
};
export const PackageVersionBadge: FC<PackageItemProps> = ({ packageVersionKey, prefix, postfix, detailed = false }) => {
  const [getPackage, { loading: packageLoading, data: packageVersionData }] =
    useGetPackageVersionLazyQuery(CACHE_FIRST);

  useEffect(() => {
    if (
      !packageLoading &&
      packageVersionKey &&
      validateUuid(packageVersionKey) &&
      packageVersionData?.getPackageVersion.uuid !== packageVersionKey
    ) {
      getPackage({
        variables: {
          uuid: packageVersionKey
        }
      });
    }
  }, [packageVersionKey]);
  if (packageLoading) {
    return (
      <Badge
        fontSize="sm"
        fontWeight="bold"
        style={{ backgroundColor: '#f2f2f2', color: '#33260b', letterSpacing: 0, marginLeft: '10px' }}
      >
        Loading
      </Badge>
    );
  }
  if (packageVersionData) {
    const versionText = `${prefix || ''}${packageVersionData?.getPackageVersion.version}${postfix || ''}`;

    return (
      <FlexLayout flexDirection="row">
        <Badge
          fontSize="sm"
          fontWeight="bold"
          style={{ backgroundColor: '#f7d677', color: '#33260b', letterSpacing: 0, marginLeft: '10px' }}
        >
          {versionText}
        </Badge>
        {detailed && (
          <FlexLayout flexDirection="row-reverse">
            Deployed at : {toLocalDateString(packageVersionData?.getPackageVersion.deployedAt || '')}
          </FlexLayout>
        )}
      </FlexLayout>
    );
  }

  return (
    <Tooltip key="tooltip" content={`Version ${packageVersionKey} not found in studio.`} direction="left">
      <Badge
        fontSize="sm"
        fontWeight="bold"
        style={{ backgroundColor: '#ff4000', color: '#33260b', letterSpacing: 0, marginLeft: '10px' }}
      >
        ?
      </Badge>
    </Tooltip>
  );
};
